import jwt_decode from 'jwt-decode'
import store from '@/store'

/**
 * 處理學生頭像 URL
 * @param {Object} student - 學生物件，必須包含 headImg 屬性
 * @returns {String} - 完整的頭像 URL
 */
export function getStudentHeadImg(student) {
  if (!student || !student.headImg) {
    return ''; // 如果沒有頭像，返回空字串
  }

  // 如果已經是 https 開頭的完整 URL，直接返回
  if (student.headImg.startsWith('https://') || student.headImg.startsWith('http://')) {
    return student.headImg;
  }

  // 取得課堂資訊
  const classInfo = store.state.classInfo?.classInfo;

  // 只有符合以下條件才處理：
  // 1. 從 IES5 來的課堂 (classInfo.isIES5 === true)
  // 2. 學生 type === 3 (簡易名單)
  // 3. headImg 包含 grouplist 或不是 https 開頭
  const isIES5 = classInfo?.isIES5 === true;
  const isSimpleRoster = student.type === 3;
  const needProcess = student.headImg.includes('grouplist');

  if (!isIES5 || !isSimpleRoster || !needProcess) {
    return student.headImg; // 不符合條件，直接返回原始值
  }

  // 組合成完整的 blob URL (只處理符合條件的路徑)
  // blobUrl + headImg + ?blobsas
  try {
    if (!classInfo?.blob?.url || !classInfo?.blob?.sas_read) {
      console.warn('Blob URL 或 SAS 不存在', classInfo);
      return student.headImg; // 無法組合，返回原始值
    }

    // 組合完整的 URL
    const blobUrl = classInfo.blob.url;
    const blobSas = classInfo.blob.sas_read;

    // 移除開頭的斜線 (如果有)
    const headImgPath = student.headImg.startsWith('/') ? student.headImg.substring(1) : student.headImg;

    // 確保 blobUrl 結尾沒有斜線
    const cleanBlobUrl = blobUrl.endsWith('/') ? blobUrl.slice(0, -1) : blobUrl;

    // 格式：blobUrl + / + headImg + ? + blobsas
    const fullUrl = `${cleanBlobUrl}/${headImgPath}?${blobSas}`;

    return fullUrl;
  } catch (err) {
    console.error('處理 headImg URL 時發生錯誤:', err);
    return student.headImg; // 發生錯誤時返回原始值
  }
}

/**
 * 判斷是否為簡易名單
 * @param {Object} student - 學生物件
 * @returns {Boolean} - 是否為簡易名單
 */
export function isSimpleRoster(student) {
  if (!student) return false;

  // 判斷條件：type 為 3 且 picture/headImg 不是 https 開頭
  if (student.type === 3 && student.headImg && !student.headImg.startsWith('https://') && !student.headImg.startsWith('http://')) {
    return true;
  }

  return false;
}
